import React, { forwardRef, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import PropTypes from 'prop-types';
import { apiClient } from '../../../modules/apiClient';
import { getUnavailableCalendarDate } from '../../../utils';
import { useWindowSize } from '../../../utils/windowSize';

const displayFormat = 'YYYY年M月D日(ddd)';

const Input = ({ value, onClick }, ref) => (
  <div className="calender" onClick={onClick}>
    {moment(value).format(displayFormat)}
  </div>
);

// Input.defaultProps = {
// };

// Input.propTypes = {
//   value: PropTypes.string,
//   onClick: PropTypes.func,
// };

const CustomInput = forwardRef(Input);

const useHolidays = () => {
  const [holidays, setHolidays] = useState([]);

  const init = async () => {
    const { data } = await apiClient.getHolidays();
    setHolidays(data);
  };

  useEffect(() => {
    init();
  }, []);

  return holidays;
};

const Calender = ({ date, minDate, maxDate, onChange, popperPlacement, readOnly }) => {
  const [isPCView, setIsPCView] = useState(false);
  const windowSize = useWindowSize();
  useEffect(() => {
    const pcView = windowSize.width > 768;
    setIsPCView(pcView);
  }, [windowSize]);

  const holidays = useHolidays();

  const selected = moment(date).toDate();

  const minDateValue = minDate ? moment(minDate).toDate() : moment().add(1, 'days').toDate();
  const maxDateValue = maxDate ? moment(maxDate).toDate() : undefined;

  const highlightDates = [
    { 'holiday': holidays.map((h) => moment(h).toDate()) },
  ];

  const unavailableDate = getUnavailableCalendarDate();
  const excludeDates = unavailableDate ? unavailableDate.map((s) => moment(s).toDate()) : undefined;

  return readOnly ? (
    <div>
      {moment(date).format(displayFormat)}
    </div>
  ) : (
    <div className="calenderWrapper">
      <DatePicker
        selected={selected}
        onChange={date => onChange(moment(date).format('YYYY-MM-DD'))}
        customInput={<CustomInput />}
        calendarClassName={`calenderBody ${popperPlacement}`}
        dayClassName={() => 'calenderDay'}
        monthsShown={isPCView ? 2 : 1}
        minDate={minDateValue}
        maxDate={maxDateValue}
        readOnly={readOnly}
        dateFormat="yyyy/MM/dd"
        dateFormatCalendar="yyyy年MM月"
        // renderCustomHeader={({
        //   date,
        //   decreaseMonth,
        //   increaseMonth,
        //   prevMonthButtonDisabled,
        //   nextMonthButtonDisabled
        // }) => (
        //   <div className="title">
        //     <div className="prevIcon" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}></div>
        //     <div className="centerText">{moment(date).format('YYYY年M月')}</div>
        //     <div className="nextIcon" onClick={increaseMonth} disabled={nextMonthButtonDisabled}></div>
        //   </div>
        // )}
        popperPlacement={popperPlacement}
        highlightDates={highlightDates}
        excludeDates={excludeDates}
      />
    </div>
  );
};

Calender.defaultProps = {
  popperPlacement: 'bottom-start',
  readOnly: false,
};

Calender.propTypes = {
  date: PropTypes.string,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  popperPlacement: PropTypes.string,
  readOnly: PropTypes.bool,
};

export default Calender;
